import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown } from "primereact/dropdown";
import apis from "../../services/apis";
import { useSmarkState } from "../../Context/KeycloakContext";
import apiUrls from "../../constants/apiUrls";
import { customFetch } from "../../helper/api-helper/apiHerlpers";
import { format } from "react-string-format";
import AppContext from "../../Context/AppContext";

const EditStory = (props) => {
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");
  const { applicationId, siteId } = useContext(AppContext);

  const [showList, setShowList] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [featureId, setFeatureId] = useState(null);

  const [masterProjects, setMasterProjects] = useState([]);
  const [masterFeatures, setMasterFeatures] = useState([]);
  const [userStories, setUserStories] = useState([]);

  const projectPermissions =
    JSON.parse(localStorage.getItem("projectPermissions")) || {};
  const isGlobalAdmin =
    JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

  useEffect(() => {
    setShowList(props.val);
  }, [props.val]);

  useEffect(() => {
    loadProjects();

    setTimeout(() => {
      const ele = document.getElementsByClassName("modal show");
      if (ele?.length) {
        ele[0].removeAttribute("tabindex");
      }
    }, 0);
  }, []);

  /* ---------------- Projects ---------------- */

  const loadProjects = async () => {
    try {
      const projects = await apis.getProjects(
        applicationId,
        siteId,
        userDetails.userId,
        userDetails.isAdminUser,
        storedToken
      );

      const filteredProjects = isGlobalAdmin
        ? projects
        : projects.filter((p) => {
            const perms = projectPermissions[p.value] || [];
            return perms.includes("EU") || perms.includes("DU"); // Edit User Story
          });

      setMasterProjects(filteredProjects);
    } catch (err) {
      console.error("Failed to load projects", err);
      setMasterProjects([]);
    }
  };

  /* ---------------- Features ---------------- */

  const loadFeatures = async (projectId) => {
    if (!projectId) {
      setMasterFeatures([]);
      return;
    }

    try {
      const response = await customFetch(
        format(apiUrls.feature, applicationId, siteId, projectId),
        storedToken
      );

      const parsed = response?.json
        ? JSON.parse(response.json)
        : response;

      const features =
        parsed?.featuresList?.map((f) => ({
          label: f.title,
          value: f.featureId,
        })) || [];

      setMasterFeatures(features);
    } catch (err) {
      console.error("Failed to load features", err);
      setMasterFeatures([]);
    }
  };

  /* ---------------- User Stories ---------------- */

  const loadUserStoriesByFeature = async (featureId) => {
    if (!featureId) {
      setUserStories([]);
      return;
    }

    try {
      const stories = await apis.getFeatureStories(
        applicationId,
        siteId,
        { featureId },
        storedToken
      );

      setUserStories(stories || []);
    } catch (err) {
      console.error("Failed to load user stories", err);
      setUserStories([]);
    }
  };

  /* ---------------- Handlers ---------------- */

  const onHideEditStory = () => {
    props.onHideEditStoryEvent(false);
  };

  const onProjectChange = async (e) => {
    const selectedProjectId = e.value;
    setProjectId(selectedProjectId);
    setFeatureId(null);
    setUserStories([]);
    setMasterFeatures([]);

    await loadFeatures(selectedProjectId);
  };

  const onFeatureChange = async (e) => {
    const selectedFeatureId = e.value;
    setFeatureId(selectedFeatureId);
    setUserStories([]);

    await loadUserStoriesByFeature(selectedFeatureId);
  };

  const editUStory = async (userStoryId) => {
    const StoryDetail = await customFetch(
      format(apiUrls.userStoryById, applicationId, siteId, userStoryId),
      storedToken
    );

    props.editUserStory(true, StoryDetail, props.header_data, "edit");
    props.onHideEditStoryEvent(false);
  };

  /* ---------------- Permission helpers ---------------- */

  const hasPermission = (permCode) => {
    if (isGlobalAdmin) return true;
    const perms = projectPermissions[projectId] || [];
    return perms.includes(permCode);
  };

  /* ---------------- UI ---------------- */

  return (
    <Modal show={showList} onHide={onHideEditStory} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>User Stories</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Project Dropdown */}
        <div style={{ margin: "10px" }}>
          <Dropdown
            filter
            placeholder="-- Select Project --"
            value={projectId}
            onChange={onProjectChange}
            options={masterProjects}
            style={{ width: "100%", zIndex: 99999 }}
          />
        </div>

        {/* Feature Dropdown */}
        {projectId && (
          <div style={{ margin: "10px" }}>
            <Dropdown
              filter
              placeholder="-- Select Feature --"
              value={featureId}
              onChange={onFeatureChange}
              options={masterFeatures}
              style={{ width: "100%", zIndex: 99999 }}
              disabled={!masterFeatures.length}
            />
          </div>
        )}

        <hr />

        {/* User Story Table */}
        {featureId && (
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th>User Story</th>
                <th style={{ textAlign: "right" }}>Action</th>
              </tr>
            </thead>

            <tbody>
              {userStories.length > 0 ? (
                userStories.map((story) => (
                  <tr key={story.value}>
                    <td>{story.label}</td>
                    <td style={{ textAlign: "right" }}>
                      {hasPermission("EU") && (
                        <>
                          <span onClick={() => editUStory(story.value)}>
                            <i className="fas fa-pencil-alt"></i>
                          </span>
                          &nbsp;&nbsp;
                        </>
                      )}

                      {hasPermission("DU") && (
                        <span onClick={() => editUStory(story.value)}>
                          <i className="fas fa-trash-alt"></i>
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} className="no-record-row">
                    No record found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EditStory;
